import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import Button from "@/components/common/Button";
import {
  googleCallbackAsync,
  selectSocialAuthError,
} from "@/store/redux/slices/auth/auth_slice";
import { FaGoogle } from "@/config/react_icons";
import { openPopupWindow } from "@/utils/oauth";
import { BASE_URL } from "@/config/api";

/**
 * Google sign-in for the dynamic polls flow — stays on the survey page after auth.
 */
const DynamicPollsGoogleButton = ({ onClick, onSuccess, onError }) => {
  const dispatch = useDispatch();
  const socialAuthError = useSelector(selectSocialAuthError);

  const handleGoogleLogin = () => {
    onClick?.();
    const popup = openPopupWindow(`${BASE_URL}/v1/auth/google`, "googleAuth");
    const pollTimer = setInterval(() => {
      try {
        if (popup.closed) {
          clearInterval(pollTimer);
          return;
        }

        const popupUrl = popup.location.href;
        if (popupUrl.includes("/callback")) {
          clearInterval(pollTimer);
          popup.close();

          dispatch(googleCallbackAsync())
            .unwrap()
            .then(() => {
              onSuccess?.();
            })
            .catch((error) => {
              console.error("Failed to complete Google authentication:", error);
              onError?.();
            });
        }
      } catch (error) {
        if (!error.message?.includes("cross-origin")) {
          console.error(error);
        }
      }
    }, 500);
  };

  return (
    <div>
      <Button
        icon={<FaGoogle />}
        color="danger"
        className="w-full h-11 preserve-bg-danger rounded-[5px] p-2.5"
        isActive={true}
        onClick={handleGoogleLogin}
      />
      {socialAuthError && (
        <p className="text-danger mt-2 text-sm">{socialAuthError}</p>
      )}
    </div>
  );
};

DynamicPollsGoogleButton.propTypes = {
  onClick: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

export default DynamicPollsGoogleButton;
